export default "__VITE_ASSET__Bir$jhJt__"